<template>
  <div>
    <component :is="componentType"></component>
  </div>
</template>

<script>
export default {
  name: "Home",

  components: {
    PcList: () => import("./ListPc.vue"), // PC端组件
    MobileList: () => import("./Mobile/List.vue"), // 移动端组件
  },

  computed: {
    componentType() {
      return this.$store.state.isMobile ? "MobileList" : "PcList";
    },
  },
};
</script>

<style scoped></style>
